import { Component, OnInit, ChangeDetectorRef, ViewChild, ChangeDetectionStrategy, OnDestroy, Input } from '@angular/core';
import { IonContent, ModalController, NavController, PopoverController } from '@ionic/angular';
import { AuftragService } from 'src/app/api/auftrag.service';
import { Router } from '@angular/router';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { AuftragHelper } from 'src/app/api/helper/auftrag-helper';
import { Auftragsstatus } from 'src/app/api/model/aufteagsstatus';
import { Logger } from 'src/app/api/helper/app-error-logger';

// https://stackoverflow.com/questions/38080654/ionic-2-angular-2-images-prepended-with-unsafe-therefore-not-displaying-ev
import { DomSanitizer } from '@angular/platform-browser';
import { MyApp } from 'src/app/api/helper/app';
import { StammdatenService } from 'src/app/api/stammdaten.service';
import { OverlayEventDetail } from '@ionic/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { WorkflowStatus, AuftragsKomponente, Adresse, ReCoMobilBild, Auftragstyp, Auftrag, MengeOptionTyp } from 'src/app/api/model/swagger-model';
import { AppConfig } from 'src/app/api/helper/app.config';
import { ClickHelper } from 'src/app/api/helper/click-helper';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { AuftragListItem, AuftragspositionEx, Barcode, WareneingangScan } from 'src/app/api/model/model';
import { Utils } from 'src/app/api/helper/utils';
import { LieferungComponent } from 'src/app/shared/components/lieferung/lieferung.component';
import { Auftragdetails } from '../auftragdetails.helper';
import { ProgloveService } from 'src/app/api/proglove.service';
import { parseBarcode } from 'src/app/api/helper/gs1-barcode-parser';
import { WareneinganScanPage } from 'src/app/shared/components/wareneingang-scan/wareneingang-scan.page';
import { BarcodeAuthGuard } from 'src/app/shared/barcode.guard';
import { SeriennummernListeComponent } from 'src/app/shared/components/seriennummern-liste/seriennummern-liste.component';

import moment from 'moment';
import { CameraHelper } from 'src/app/shared/helper/camera-helper';

declare var cordova: any;

@Component({
    selector: 'app-auftragdetails-wareneingang',
    templateUrl: './auftragdetails-wareneingang.component.html',
    styleUrls: ['./auftragdetails-wareneingang.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragdetailsWareneingangComponent implements OnInit, OnDestroy {
    log = new Logger("AuftragdetailsWareneingangComponent");

    @ViewChild('content', { static: false }) content: IonContent;
    @ViewChild('appLieferung', { read: LieferungComponent, static: false }) appLieferung: LieferungComponent;

    @Input() auftragdetails: Auftragdetails;

    app = MyApp.current;

    key: string = null;
    auftragsnummer: number = null;
    abholdatum: string;
    abholdatumClassName: string;
    summeArtikelkosten = 0;
    kameraAktiv = false;
    alertAktiv = false;
    dateienVorhanden = false;
    unterMandant = '';

    lieferungAnzeigen = new BehaviorSubject<boolean>(true);
    fotos = new BehaviorSubject<boolean>(true);
    anmerkungen = new BehaviorSubject<boolean>(true);

    anzeigeBild: BildVO = null;

    geladen = false;
    isDestroyed = false;
    isVisible = false;
    initialisiert = false;
    isGedruckt = false;
    isAbgeschlossen = false;

    isWareneingang = false;

    subscriptions: Subscription[] = [];

    statuszusatzinfoModal: HTMLIonModalElement;

    highlightPosition = new BehaviorSubject<number>(-9999);
    letzteErkennung = 0;
    isModalSichtbar = false;

    proGloveLetzteGescanntePositionNr = 0;
    progloveSeriennummerScanAlert: HTMLIonAlertElement;
    // progloveSeriennummerScanPosition: AuftragspositionEx;

    progloveSeriennummerPos: number = 0;
    progloveSeriennummerAnzahl: number = 0;
    bestellungen: Auftrag[];

    lieferung: Auftrag = null;

    wareneingangScan: WareneingangScan = null;
    wareneingangScanPopover: HTMLIonPopoverElement;

    isDebugButtonsAnzeigen = false;
    isLieferantAusgewaehlt = false;

    constructor(
        private auftragService: AuftragService,
        private modalController: ModalController,
        private popoverController: PopoverController,
        private stammdatenService: StammdatenService,
        public domSanitizationService: DomSanitizer,
        private fileOpener: FileOpener,
        private cdr: ChangeDetectorRef,
        private router: Router,
        private nav: NavController,
        private progloveService: ProgloveService) {

    }

    get auftrag() { return this.auftragdetails.auftrag; };
    get workflow() { return this.auftragdetails.workflow; };
    get formularKonfiguration() { return this.auftragdetails.formularKonfiguration; };
    get checklisten() { return this.auftragdetails.checklisten; };
    get auftragsbilder() { return this.auftragdetails.auftragsbilder; };
    get bilder() { return this.auftragdetails.bilder; };
    get buttons() { return this.auftragdetails.buttons; };
    get buttons2() { return this.auftragdetails.buttons2; };
    get buttons3() { return this.auftragdetails.buttons3; };

    async ngOnInit() {
        this.log?.debug('ngOnInit');

        try {
            this.isWareneingang = true;
            this.isDebugButtonsAnzeigen = !MyApp.isCordovaAvailable();

            this.auftragsnummer = this.auftrag.Auftragsnummer;

            if (!this.auftrag.Erzeugeradresse) {
                // Es muss immer eine Erzeugeradresse (Lieferant) existieren.
                // Kann auch leer sein. Muss dann ausgewählt werden
                this.auftrag.Erzeugeradresse = {

                }
            }

            this.lieferungAnzeigen.next(this.workflow.einstellungen.LieferungAnzeigen !== 'nein');
            this.fotos.next(this.workflow.einstellungen.Fotos !== 'nein');
            this.anmerkungen.next(this.workflow.einstellungen.Anmerkungen !== 'nein');

            if (this.isWareneingang && !this.auftrag.OberAuftragKey) {
                this.lieferungAnzeigen.next(false);
            }

            this.log?.info('formularKonfiguration', this.formularKonfiguration);

            this.dateienVorhanden = this.auftrag.Anlagen && this.auftrag.Anlagen.length > 0;

            await this.auftragdetails.init();

            this.abholdatum = AuftragHelper.getAbholdatumText(this.auftrag);
            this.abholdatumClassName = AuftragHelper.getAbholdatumClassName(this.auftrag);

            this.geladen = true;

            this.unterMandant = '';

            if (this.auftrag.UnterMandant) {
                if (AppConfig.current.UnterMandant) {
                    if (this.auftrag.UnterMandant.trim().toUpperCase() !== AppConfig.current.UnterMandant.trim().toUpperCase()) {
                        // Es handelt sich um einen Auftrag von einem anderen Untermandanten als das Gerät zugeordnet ist
                        this.unterMandant = this.auftrag.UnterMandant;
                    }
                }
            }

            if (this.auftrag.Lieferungen?.length) {
                this.lieferung = this.auftrag.Lieferungen[0];
            }

            // if (this.auftrag.Auftragstyp == Auftragstyp.Transportauftrag) {
            //     if (AppConfig.current.einstellungen.TransportauftragFahrzeugKennzeichenPruefen == 'oeffnen') {
            //         // Prüfe ob das Kennzeichen zum angemeldeten Fahrzeug passt
            //         if (this.auftrag.FahrzeugKennung) {
            //             const fahrzeugKennzeichen = Utils.trimToEmpty(App.current.getFahrzeugKennzeichen());

            //             if (fahrzeugKennzeichen) {
            //                 if (fahrzeugKennzeichen != this.auftrag.FahrzeugKennung) {
            //                     UiHelper.showAlert(`Auftrag ist geplant für Fahrzeug \n${this.auftrag.FahrzeugKennung}.\nTour wurde mit Fahrzeug \n${fahrzeugKennzeichen} \ngestartet.`, 'Achtung');
            //                 }
            //             }
            //         }
            //     }
            // }

            this.subscriptions.push(this.progloveService.barcodeReceived.subscribe((barcode) => {
                this.verarbeiteBarcodeScan(barcode, true);
            }));

            this.subscriptions.push(this.auftragdetails.detectChanges.subscribe(info => { this.detectChanges(info); }));

            setTimeout(() => {
                this.starteAuftragAufProGlove();
            }, 100);

            this.subscriptions.push(this.auftragdetails.detectChanges.subscribe(info => this.detectChanges(info)));
            this.subscriptions.push(this.auftragdetails.auftragAbgeschlossen.subscribe(() => this.goBack()));
            this.subscriptions.push(this.auftragdetails.lieferungAnzeigen.subscribe(() => this.lieferungAendern()));
            this.subscriptions.push(this.auftragdetails.druckenAnzeigen.subscribe(workflowStatus => this.auftragdetails.anzeigenDrucken(workflowStatus)));
            this.subscriptions.push(this.auftragdetails.bezahlenAnzeigen.subscribe(workflowStatus => this.auftragdetails.anzeigenBezahlen(workflowStatus)));
            this.subscriptions.push(this.auftragdetails.weiterleitenAnzeigen.subscribe(workflowStatus => this.auftragdetails.anzeigenWeiterleiten(workflowStatus)));
            this.subscriptions.push(this.auftragdetails.scrollToButtons.subscribe(() => this.scrollToButtons()));
            this.subscriptions.push(this.auftragdetails.anmerkungenAnzeigen.subscribe(() => this.auftragdetails.anzeigenAnmerkungen()));
            this.subscriptions.push(this.auftragdetails.auftragspositionFertigChanged.subscribe((position) => this.onAuftragspositionFertigChanged(position)));

            if (!this.auftragdetails.istAuftragAbgeschlossen) {
                if (this.auftrag.Erzeugeradresse?.AdressNummer) {
                    await this.ladeBestellungen();
                }
            }

            this.isLieferantAusgewaehlt = !!this.auftrag.Erzeugeradresse.AdressNummer;
            this.isAbgeschlossen = this.auftragdetails.istAuftragAbgeschlossen;

            this.detectChanges('ngOnInit');

            this.initialisiert = true;
        } catch (err) {
            this.log.error('ngOnInit', err);
        }
    }

    detectChanges(info: string) {
        if (!this.isDestroyed) {
            this.log?.debug('detectChanges: ' + info);
            this.cdr.detectChanges();
        }
    }

    ngOnDestroy() {
        this.log?.debug('ngOnDestroy');

        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];

        this.entferneAuftragVonProGlove();

        this.isDestroyed = true;
    }

    async ionViewWillEnter() {
        this.log?.debug('ionViewWillEnter');
    }

    async ionViewDidEnter() {
        this.log?.debug('ionViewDidEnter');
        this.isVisible = true;
        MyApp.current.backAction = () => this.goBack();

        let ttl = 20;

        while (!this.auftrag) {
            await MyApp.delay(100);

            if (ttl-- < 0) {
                break;
            }
        }

        this.auftragService.setzeAktivenAuftrag(this.auftrag, 'auftragdetails');

        if (this.appLieferung) {
            this.appLieferung.refresh();
        }

        this.detectChanges('ionViewDidEnter');
    }

    ionViewWillLeave() {
        this.isVisible = false;

        MyApp.current.backAction = null;
        this.auftragService.setzeAktivenAuftrag(null, 'auftragdetails exit');
    }

    async goBack() {
        this.log?.debug('goBack');

        if (this.anzeigeBild) {
            this.log?.debug('goBack abbruch wegen anzeigeBild');
            this.anzeigeBild = null;
            return;
        }

        if (this.alertAktiv) {
            this.log?.debug('goBack abbruch wegen alertAktiv');
            // ignoriere Hardware-Back-Button
            return;
        }

        if (this.kameraAktiv) {
            this.log?.debug('goBack abbruch wegen kameraAktiv');
            // ignoriere Hardware-Back-Button
            return;
        }

        if (this.auftrag) {
            if (this.auftrag.OberAuftragKey) {
                await this.nav.navigateBack('/auftragsliste/details/' + this.auftrag.OberAuftragKey);
            } else {
                await this.nav.navigateBack('/auftragsliste/aktuell/' + this.auftrag.Auftragstyp);
            }
        } else {
            await this.nav.navigateRoot('/');
        }
    }

    async statusMelden(status: WorkflowStatus, mitRueckfrage: boolean): Promise<void> {
        await this.auftragdetails.statusMelden(status, mitRueckfrage);
    }

    scrollToButtons() {
        const formularKonfiguration = this.formularKonfiguration;

        // Nur nach unten scrollen, wenn die Buttons ganz unten angezeigt werden
        if (formularKonfiguration && formularKonfiguration.komponenten && formularKonfiguration.komponenten.length) {
            const letzteKomponente = formularKonfiguration.komponenten[formularKonfiguration.komponenten.length - 1];

            if (letzteKomponente.name == 'Buttons') {
                setTimeout(() => {
                    if (this.content) {
                        this.content.scrollToBottom(300)
                    }
                }, 250);
            }
        }
    }

    async onAnrufen(adresse: Adresse) {
        this.auftragdetails.anrufen(adresse);
    }

    async onNavigationStarten(adresse: Adresse) {
        this.log?.debug('onNavigationStarten');
        this.auftragdetails.starteNavigation(adresse);
    }

    // async onOptionenAnzeigen() {
    //     const that = this;

    //     const buttons: ActionSheetButton[] = [];

    //     if (this.navigation.getValue()) {
    //         buttons.push({
    //             text: 'Navigation zu Einsatzort',
    //             role: 'destructive',
    //             icon: 'navigate',
    //             handler: () => {
    //                 this.auftragdetails.starteNavigation(this.auftrag.Abholadresse);
    //             }
    //         });
    //     }

    //     if (this.fotos.getValue() && !this.istAuftragAbgeschlossen) {
    //         buttons.push({
    //             text: 'Foto aufnehmen',
    //             icon: 'camera',
    //             handler: () => {
    //                 that.onFotoAufnehmen();
    //             }
    //         });
    //     }

    //     if (this.lieferungAnzeigen.getValue() && !this.istAuftragAbgeschlossen) {
    //         buttons.push({
    //             text: 'Lieferung ändern',
    //             icon: 'basket',
    //             handler: () => {
    //                 that.lieferungAendern();
    //             }
    //         });
    //     }

    //     if (AppConfig.current.einstellungen.AuftragBarcodeButtonVerfuegbar === 'ja') {
    //         buttons.push({
    //             text: 'Barcode anzeigen',
    //             icon: 'barcode',
    //             handler: () => {
    //                 this.auftragdetails.anzeigenBarcode();
    //             }
    //         });
    //     }

    //     buttons.push({
    //         text: 'Abbruch',
    //         icon: 'close',
    //         role: 'cancel',
    //         handler: () => {
    //             this.log?.debug('Cancel clicked');
    //         }
    //     });

    //     const actionSheet = await this.actionSheetController.create({
    //         header: 'Mehr',
    //         buttons
    //     });

    //     await actionSheet.present();
    // }

    istAuftragZugewiesen(unterauftrag: AuftragListItem) {
        return unterauftrag.Auftragsstatus >= Auftragsstatus.Zugewiesen
            && unterauftrag.Geraet === AppConfig.current.geraeteNummer;
    }

    async onLieferungClicked(e: TouchEvent) {
        this.log?.debug('onLieferungClicked', e);

        if (e.target) {
            const element = e.target as HTMLElement;

            if (element.tagName && element.tagName.toUpperCase() == "ION-BUTTON") {
                // Ignorieren. Es wurde auf einen Plus/Minus-Button geklickt
                return;
            }
        }

        this.lieferungAendern();
    }

    private lieferungAendern() {
        this.auftragdetails.lieferungAendern();
    }

    async onFotoAufnehmenClicked(e: Event) {
        ClickHelper.click(e, () => this.onFotoAufnehmen());
    }

    async onFotoAufnehmen() {
        if (this.auftragdetails.isBilderErfassenGesperrt) {
            UiHelper.showAlert('Auftrag ist schreibgeschützt. Änderungen sind nicht mehr möglich.');
            return;
        }

        // imageData is a base64 encoded string
        // this.base64Image = "data:image/jpeg;base64," + imageData;
        this.kameraAktiv = true;

        let pictureSrc = await CameraHelper.takePicture({
            filenamePrefix: 'auftrag-' + this.auftrag.Auftragsnummer,
        });

        if (!pictureSrc) {
            setTimeout(() => {
                this.kameraAktiv = false;
            }, 250);

            return;
        }

        this.log?.debug('pictureSrc', pictureSrc);

        const bild: ReCoMobilBild = {
            Datum: new Date().toISOString(),
            // Bild: imageData,
            BildGuid: Utils.uuid()
        };

        await this.auftragService.speichereBild(bild.BildGuid, pictureSrc);

        if (!this.auftrag.Auftragsbilder) {
            this.auftrag.Auftragsbilder = [];
        }

        this.auftrag.Auftragsbilder.push(bild);

        await this.auftragService.speichereAuftrag(this.auftrag);

        this.auftragsbilder.push(await this.auftragdetails.createBildVo(bild));

        this.detectChanges('onFotoAufnehmen');

        setTimeout(() => {
            this.kameraAktiv = false;
        }, 250);

        // setTimeout(() => this.content.scrollToBottom(300), 250);
    }

    async onBildClicked(vo: BildVO) {
        this.anzeigeBild = vo;
    }

    async doBildAnzeigen(vo: BildVO) {
        const filePath = await this.auftragService.getBildSrc(vo.guid);
        await this.fileOpener.open(filePath, 'image/jpeg');
    }

    showAuftragsbild(p: BildVO) {
        this.router.navigateByUrl('/auftragsliste/details/' + this.auftrag.Key + '/bild/' + p.nummer);
    }

    onAnmerkungenBearbeiten() {
        if (this.auftragdetails.isAnmerkungenErfassenGesperrt) {
            return;
        }

        this.router.navigateByUrl('/auftragsliste/details/' + this.auftrag.Key + '/anmerkungen');
    }

    async anzeigenBarcode() {
        this.auftragdetails.anzeigenBarcode();
    }

    getEinstellung(komponente: AuftragsKomponente, key: string, defaultValue: string): string {
        return this.auftragdetails.getEinstellung(komponente, key, defaultValue);
    }

    getStyle(komponente: AuftragsKomponente): string {
        return this.auftragdetails.getStyle(komponente);
    }

    istStatusuebergangErlaubt(workflowStatus: WorkflowStatus) {
        if (!this.auftrag) {
            return false;
        }

        if (!workflowStatus) {
            return true;
        }

        return this.auftragService.istStatusuebergangErlaubt(this.auftrag, this.workflow, workflowStatus);
    }

    getTitel(): string {
        if (this.auftrag) {
            if (this.auftrag.Auftragstyp == Auftragstyp.Wareneingang) {
                if (this.auftrag.OberAuftragKey) {
                    return 'Palette ' + this.auftrag.label;
                } else {
                    return 'Tour ' + this.auftragsnummer;
                }
            }
        }

        let text = 'Auftrag ' + this.auftragsnummer;

        if (this.unterMandant) {
            text += ', ' + this.unterMandant;
        }

        return text;
    }

    getUnterauftragIcon(unterauftrag: AuftragListItem): string {
        switch (unterauftrag.Auftragsstatus) {
            case Auftragsstatus.Unbekannt:
            case Auftragsstatus.Neu:
                return 'help';
            case Auftragsstatus.Zugewiesen:
                return 'pricetag';
            case Auftragsstatus.InBearbeitung:
                return 'play';
            case Auftragsstatus.Unterbrochen:
                return 'pause';
            case Auftragsstatus.Abgeschlossen:
                return 'checkmark';
            case Auftragsstatus.Abgelehnt:
                return 'hand';
            case Auftragsstatus.Geloescht:
                return 'close';
            default:
                return 'help';
        }
    }

    getUnterauftragClassName(unterauftrag: AuftragListItem): string {
        return 'auftragsstatus-' + unterauftrag.Auftragsstatus;
    }

    async starteAuftragAufProGlove() {
        if (!MyApp.current.ProGloveVerfuegbar.getValue()) {
            return;
        }

        if (this.auftrag.Auftragsstatus >= 90) {
            return;
        }

        this.log?.info('starteAuftragAufProGlove');

        await this.progloveService.setWareneingangProfile(true);

        await this.progloveService.displayTemplate(
            'PG1A',
            `1|Wareneingang|Scan`,
            '|',
            0
        );
    }

    async onAuftragspositionFertigChanged(position: AuftragspositionEx) {
        this.log?.debug('onAuftragspositionFertigChanged: ' + position.Fertig);

        if (position.Fertig) {
            // TODO ?
        }
    }

    async entferneAuftragVonProGlove() {
        if (!MyApp.current.ProGloveVerfuegbar.getValue()) {
            return;
        }

        if (this.auftrag.Auftragstyp === Auftragstyp.Wareneingang) {
            if (this.auftrag.OberAuftragKey) {
                await this.progloveService.displayTemplate(
                    'PG1A',
                    `1||Warte auf Daten`,
                    '|',
                    0
                );
            }
        }
    }

    async onButtonClicked(button: ButtonVO) {
        if (this.auftragdetails.istAuftragAbgeschlossen) {
            let erlaubt = false;

            if (button.workflowStatus) {
                erlaubt = button.workflowStatus.NachAbschlussErlaubt;
            }

            if (!erlaubt) {
                this.auftragdetails.showAuftragArchiviert();
                return;
            }
        }

        if (button.workflowStatus) {
            await this.auftragdetails.statusMelden(button.workflowStatus, true);
        } else {
            this.auftragdetails.onStatusmeldung();
        }
    }

    async onSimuliereBarcode(format: string, text: string) {
        await this.verarbeiteBarcodeScan({
            format: format,
            text: text
        });
    }

    async onSimuliereBarcodeAB() {
        await this.verarbeiteBarcodeScan({
            format: 'GS1-128',
            text: '020401871506013033020713003740'
        });

        await Utils.delay(2000);

        await this.verarbeiteBarcodeScan({
            format: 'GS1-128',
            text: '152209241020210823302090000013'
        });
    }

    async verarbeiteBarcodeScan(barcode: Barcode, vonProGlove = false) {
        this.log?.debug('verarbeiteBarcodeVonProGlove: ' + barcode.text + ', ' + barcode.format);

        if (!this.auftrag) {
            return;
        }

        // if (this.progloveSeriennummerScanPosition) {
        //     // Es wird gerade eine Seriennummer für eine Position gescannt
        //     await this.verarbeiteSeriennummerBarcodeVonProGlove(barcode);
        //     return;
        // }

        const personalKey = MyApp.current.getPersonalKey();

        if (!this.wareneingangScan) {
            this.wareneingangScan = {
                artikelNr: null,
                charge: '',
                gtin: '',
                nve: '',
                mhd: '',
                menge: null
            }
        }

        let artikelNr = '';
        let charge = '';
        let gtin = '';
        let nve = '';
        let mhd = '';
        let menge = '';

        let isGS1 = Utils.isGS1Barcode(barcode);

        if (isGS1) {
            // Aufbau ist über das Format eindeutig definiert
            // https://de.wikipedia.org/wiki/GS1-128
            const result = parseBarcode(barcode.text);

            this.log?.debug('Barcode parse Result', result);

            if (result?.parsedCodeItems) {
                for (const item of result.parsedCodeItems) {
                    const ai = item.ai as string;
                    const raw = item.raw as string;

                    switch (ai) {
                        case '01':
                            // Global Trade Item Number
                            gtin = raw;
                            break;

                        case '02':
                            // CONTENT
                            // GTIN der Handelseinheiten, enthalten in einer logistischen Einheit
                            gtin = raw;
                            break;

                        case '10':
                            // Losnummer/Chargennummer des Artikels
                            charge = raw;
                            break;

                        // case '10':
                        //     // Herstellungsdatum                            
                        //     break;

                        case '30':
                            // MENGE
                            break;

                        case '37':
                            // MENGE (enthalten in einer logistischen Einheit)
                            menge = raw;
                            break;

                        case '15': {
                            // Mindesthaltbarkeitsdatum 
                            const date = item.data as Date;
                            const datum = moment(date);
                            mhd = datum.format('DD.MM.YYYY');
                            break;
                        }

                        case '17': {
                            // Verfallsdatum
                            const date = item.data as Date;
                            const datum = moment(date);
                            mhd = datum.format('DD.MM.YYYY');
                            break;
                        }
                    }
                }
            }
        } else {
            if (vonProGlove) {
                this.progloveService.triggerFeedback(2);
                this.progloveService.displayError('Kein GS1');
            }

            return;
        }

        if (artikelNr) {
            this.wareneingangScan.artikelNr = parseInt(artikelNr, 10);
        }

        if (charge) {
            this.wareneingangScan.charge = charge;
        }

        if (mhd) {
            this.wareneingangScan.mhd = mhd;
        }

        if (nve) {
            this.wareneingangScan.nve = nve;
        }

        if (menge) {
            this.wareneingangScan.menge = parseInt(menge, 10);
        }

        if (gtin) {
            const gtinVal = parseInt(gtin, 10);

            this.wareneingangScan.gtin = gtin;

            // Suche einen passenden Artikel in den Stammdaten mit der GTIN
            let artikel = this.stammdatenService.artikelListe.getValue().find(p => p.GTIN == gtin);

            if (!artikel) {
                artikel = this.stammdatenService.artikelListe.getValue().find(p => Utils.parseInt(p.GTIN) == gtinVal);
            }

            if (!artikel) {
                if (vonProGlove) {
                    this.progloveService.triggerFeedback(2);
                    this.progloveService.displayError('Unbekannter Artikel');
                } else {
                    UiHelper.showAlert('Unbekannter Artikel: ' + gtin);
                    return;
                }

                return;
            }

            this.wareneingangScan.artikelNr = artikel.artikelKey;
        }

        // Prüfe ob bereits der Scan-Dialog angezeigt wird. Wenn nicht, jetzt anzeigen.
        // Wenn ja, aktualisieren
        if (this.wareneingangScanPopover) {
            const wareneinganScanPage = WareneinganScanPage.instance;

            if (wareneinganScanPage) {
                wareneinganScanPage.update(true);
            }
        } else {
            this.wareneingangScanPopover = await this.popoverController.create({
                component: WareneinganScanPage,
                animated: false,
                backdropDismiss: true,
                cssClass: 'wareneingang-popover',
                componentProps: {
                    'entity': this.wareneingangScan,
                    'isAendern': false
                }
            });

            await this.wareneingangScanPopover.present();

            this.wareneingangScanPopover.onDidDismiss().then((result) => this.handleWareneingangScanPopoverDismissed(result));
        }

        if (vonProGlove) {
            if (artikelNr || charge || mhd || menge) {
                this.progloveService.triggerFeedback(1);
            }
        }
    }

    async handleWareneingangScanPopoverDismissed(result: OverlayEventDetail<any>) {
        this.log?.debug('wareneingangScanPopover onDidDismiss');

        if (result.data) {
            if (result.data === 'OK') {
                // Drucken
                let artikel = this.stammdatenService.artikelListe.getValue().find(p => p.artikelKey == this.wareneingangScan.artikelNr);

                if (!artikel) {
                    UiHelper.showAlert('Artikel nicht gefunden: ' + this.wareneingangScan.artikelNr);
                    return;
                }

                // Ermitle die nächste Positionsnummer
                let posNr = 1;

                if (this.auftrag.Positionen.length) {
                    posNr = Math.max(... this.auftrag.Positionen.map(p => p.PosNr)) + 1;
                }

                const position: AuftragspositionEx = {
                    PosNr: posNr,
                    ArtikelKey: this.wareneingangScan.artikelNr?.toString(),
                    Bezeichnung: artikel.bezeichnung,
                    LPN: artikel.LPN,
                    GTIN: artikel.GTIN,
                    Einheit: artikel.einheit,
                    SeriennummerErforderlich: artikel.SeriennummerErforderlich,
                    Menge: this.wareneingangScan.menge,
                    MengeOption: MengeOptionTyp.Aenderbar,
                    IstNeu: true,
                    Eigenschaften: [
                        {
                            Key: 'MHD',
                            Bezeichnung: 'MHD',
                            Typ: 'datum',
                            Wert: this.wareneingangScan.mhd
                        },
                        // {
                        //     Key: 'GTIN',
                        //     Bezeichnung: 'GTIN',
                        //     Typ: 'text',
                        //     Wert: this.wareneingangScan.gtin
                        // },
                        {
                            Key: 'CHARGE',
                            Bezeichnung: 'Charge',
                            Typ: 'text',
                            Wert: this.wareneingangScan.charge
                        },
                        {
                            Key: 'NVE',
                            Bezeichnung: 'NVE',
                            Typ: 'text',
                            Wert: this.wareneingangScan.nve
                        },
                    ]
                };

                this.auftrag.Positionen.push(position);

                this.auftragService.speichereAuftrag(this.auftrag);

                this.auftragdetails.auftragspositionenGeaendert.next();
                this.auftragdetails.detectChanges.next('verarbeiteBarcodeVonProGlove');

                // this.progloveService.triggerFeedback(1);

                this.wareneingangScan = null;

                if (position.SeriennummerErforderlich) {
                    const modal = await this.modalController.create({
                        component: SeriennummernListeComponent,
                        componentProps: {
                            'auftrag': this.auftrag,
                            'position': position,
                            'auftragdetails': this.auftragdetails
                        }
                    });

                    await modal.present();

                    await modal.onDidDismiss();

                    this.cdr.detectChanges();
                } else {
                    // Nur drucken, falls keine Seriennummer erforderlich ist.
                    // Für Seriennummer-geführte Artikel wird (derzeit) kein Etikett benötigt
                    this.auftragdetails.druckenAuftragsposition(position);
                }
            } else if (result.data === 'loeschen') {
                // TODO
                // if (this.auftrag) {
                //     const idx = this.auftrag.Stoerzeiten.findIndex(p => p.Guid == item.Guid);

                //     if (idx >= 0) {
                //         this.auftrag.Stoerzeiten.splice(idx, 1);

                //         this.auftragService.speichereAuftrag(this.auftrag);
                //     }
                // } else if (this.tourStatus) {
                //     const idx = this.tourStatus.Stoerzeiten.indexOf(item);

                //     if (idx >= 0) {
                //         this.tourStatus.Stoerzeiten.splice(idx, 1);

                //         // TODO
                //     }
                // }

            } else {
                // speichern

                if (this.auftrag) {
                    this.auftragService.speichereAuftrag(this.auftrag);

                    this.auftragdetails.auftragspositionenGeaendert.next();
                    this.auftragdetails.detectChanges.next('verarbeiteBarcodeVonProGlove');
                }
            }

            this.cdr.detectChanges();
        }

        this.wareneingangScanPopover = null;
    }

    // async verarbeiteSeriennummerBarcodeVonProGlove(barcode: Barcode) {
    //     this.log?.debug('verarbeiteSeriennummerBarcodeVonProGlove: ' + barcode.text + ', ' + barcode.text);

    //     const position = this.progloveSeriennummerScanPosition;

    //     if (!this.auftrag || !position) {
    //         this.log.warn('Kein Auftrag oder keine Position');
    //         return;
    //     }

    //     if (barcode.format === 'GS1-128') {
    //         this.log.warn('Fehler. Seriennummer kann kein GS1 sein !');
    //         this.progloveService.triggerFeedback(2);
    //         return;
    //     }

    //     this.progloveService.triggerFeedback(1);

    //     this.auftrag.Protokoll.push({
    //         Datum: Utils.nowIsoDateString(),
    //         Typ: 'Seriennummer',
    //         Text: position.Bezeichnung,
    //         Info1: barcode.text,
    //         Info2: barcode.format,
    //     });

    //     // this.log?.debug(`Position ${position.PosNr} ist fertig`);

    //     // position.Fertig = true;

    //     if (this.progloveSeriennummerPos > 1) {
    //         AuftragHelper.setzeEigenschaft(position, 'Seriennummer ' + this.progloveSeriennummerPos, barcode.text);
    //     } else {
    //         AuftragHelper.setzeEigenschaft(position, 'Seriennummer', barcode.text);
    //     }

    //     this.proGloveLetzteGescanntePositionNr = position.PosNr;

    //     // this.log?.debug('Speichere Auftrag START');

    //     // await this.auftragService.speichereAuftrag(this.auftrag);

    //     // this.log?.debug('Speichere Auftrag ENDE');

    //     this.auftragdetails.detectChanges.next('verarbeiteBarcodeVonProGlove');

    //     if (this.progloveSeriennummerScanAlert) {
    //         this.progloveSeriennummerScanAlert.dismiss();
    //         this.progloveSeriennummerScanAlert = null;
    //     }

    //     // await this.sendeNaechstePositionAnProGlove();
    // }

    // async onNeuePosition() {
    //     this.log?.debug('onNeuePosition');

    //     this.wareneingangScan = {
    //         artikelNr: null,
    //         charge: '',
    //         gtin: '',
    //         nve: '',
    //         mhd: '',
    //         menge: null
    //     };

    //     this.wareneingangScanPopover = await this.popoverController.create({
    //         component: WareneinganScanPage,
    //         animated: false,
    //         backdropDismiss: false,
    //         cssClass: 'wareneingang-popover',
    //         componentProps: {
    //             'entity': this.wareneingangScan,
    //             'isAendern': false
    //         }
    //     });

    //     await this.wareneingangScanPopover.present();

    //     this.wareneingangScanPopover.onDidDismiss().then((result) => this.handleWareneingangScanPopoverDismissed(result));
    // }

    async onLieferantChanged(adresse: Adresse) {
        this.log?.debug('onLieferantChanged', adresse);

        if (adresse) {
            this.auftrag.Abholadresse.AdressNummer = adresse.AdressNummer;
            this.auftrag.Abholadresse.Name1 = adresse.Name1;
        }

        this.isLieferantAusgewaehlt = !!this.auftrag.Erzeugeradresse.AdressNummer;

        await this.ladeBestellungen();
    }

    async ladeBestellungen() {
        // Derzeit nicht notwendig

        // if (!this.auftrag?.Erzeugeradresse?.AdressNummer) {
        //     this.bestellungen = null;
        //     return;
        // }

        // let loadingCanceled = false;

        // await UiHelper.showLoading('Bestellungen werden geladen...', true, () => { loadingCanceled = true });

        // try {
        //     const adresse = this.auftrag.Erzeugeradresse;

        //     const result = await this.remoteService.sucheBestellungen({
        //         AdressNummer: adresse.AdressNummer,
        //     });

        //     if (loadingCanceled) {
        //         return;
        //     }

        //     await UiHelper.hideLoading();

        //     this.bestellungen = [];

        //     if (result?.Success) {
        //         this.bestellungen = result.Bestellungen;

        //         if (this.lieferung) {
        //             // Referenz zum Objekt wiederherstellen, damit in der Dropdown-Liste die Lieferung/Bestellung ausgewählt ist
        //             const refLieferung = this.bestellungen.find(p => p.Auftragsnummer === this.lieferung.Auftragsnummer);

        //             if (refLieferung) {
        //                 this.lieferung = refLieferung;
        //             }
        //         }
        //     } else if (result.ErrorMessage) {
        //         UiHelper.showErrorOhneSentry(result.ErrorMessage);
        //     } else {
        //         UiHelper.showFehlerKommunikation();
        //     }

        //     this.cdr.detectChanges();
        // } catch (err) {
        //     await UiHelper.hideLoading();
        //     UiHelper.showErrorOhneSentry(err);
        // }
    }

    async onLieferungChanged() {
        this.log?.debug('onLieferungChanged', this.lieferung);

        this.auftrag.SollPositionen = [];

        if (this.lieferung) {
            this.auftrag.Auftragsnummer = this.lieferung.Auftragsnummer;
            // this.auftrag.Key = 'W' + this.auftrag.Auftragsnummer;
            this.auftrag.Lieferungen = [this.lieferung];

            // Kopiere die Positionen der Lieferung
            this.auftrag.SollPositionen = [... this.lieferung.Positionen];

            // for (let i = 0; i < this.lieferung.Positionen.length; i++) {
            //     this.auftrag.Positionen[i] = { ... this.lieferung.Positionen[i] };
            // }
        } else {
            this.auftrag.Lieferungen = [];
        }

        await this.auftragService.speichereAuftrag(this.auftrag);

        this.auftragdetails.auftragspositionenGeaendert.next();
        this.auftragdetails.detectChanges.next('onLieferungChanged');
    }

    async onBarcodeScan() {
        BarcodeAuthGuard.barcodeScanAktiv = true;

        try {
            // TODO CAPACITOR: format wird noch nicht zurückgegeben
            let barcodeData = await MyApp.scanBarcode({
                debugFallback: '020401871506013033020713003740',
                debugFormat: 'CODE_128'
            });


            if (barcodeData?.text) {
                let format: string = barcodeData.format;

                if (format == 'CODE_128') {
                    format = 'GS1-128';
                }

                await this.verarbeiteBarcodeScan({
                    text: barcodeData.text,
                    format: format
                });
            }

            this.cdr.detectChanges();

        } catch (err) {
            UiHelper.showError(err);
        }

        setTimeout(() => BarcodeAuthGuard.barcodeScanAktiv = false, 500);
    }
}

interface BildVO {
    src: string;
    datum?: string;
    nummer?: number;
    guid: string;
    bezeichnung: string;
}

interface ButtonVO {
    text: string;
    icon: string;
    color: string;
    workflowStatus: WorkflowStatus;
}


